/**
 * Ленивая загрузка аварийного режима (G4) — тот же паттерн, что IsoLazy/ArLazy:
 * чанк нужен не каждому посетителю (укрытия, эвакуационная схема, внешние
 * тревоги), стартовый бандл его не платит (check:bundle).
 *
 * `warmEmergencyPanel()` (план 24.09 п.1) тянет тот же чанк заранее, в простое
 * после загрузки карты — иначе посетитель без сети, ни разу не открывавший
 * ЧС онлайн, получил бы на тревоге пустой экран: SW кладёт в кеш только то,
 * что реально было запрошено (см. web/src/sw/warm-assets.ts). Модульный кеш
 * (`cached`) общий с EmergencyLazy — повторного импорта при показе нет.
 */
import type { ComponentType } from 'preact'
import { useEffect, useState } from 'preact/hooks'
import { importChunk } from '../lazy-retry'

let cached: ComponentType | null = null
let warming: Promise<void> | null = null

/** Заранее прогреть чанк аварийного режима (main.tsx, idle после карты). */
export function warmEmergencyPanel(): Promise<void> {
  if (cached) return Promise.resolve()
  if (warming) return warming
  warming = importChunk(() => import('./emergency-panel'))
    .then((m) => {
      cached = m.EmergencyPanel
    })
    .catch(() => {
      // Сеть пропала до прогрева — следующий вызов (событие online, main.tsx)
      // попробует снова, а не вернёт этот провал навсегда.
      warming = null
    })
  return warming
}

export function EmergencyLazy() {
  // Ленивый инициализатор обязателен (см. IsoLazy): иначе Preact вызвал бы
  // компонент как функцию-инициализатор состояния.
  const [View, setView] = useState<ComponentType | null>(() => cached)

  useEffect(() => {
    if (View) return
    let alive = true
    void importChunk(() => import('./emergency-panel'))
      .then((m) => {
        cached = m.EmergencyPanel
        if (alive) setView(() => m.EmergencyPanel)
      })
      .catch(() => undefined)
    return () => {
      alive = false
    }
  }, [View])

  if (!View) return null
  return <View />
}
